import { render, staticRenderFns } from "./CreatePersonal.vue?vue&type=template&id=e60246c8&"
import script from "./CreatePersonal.vue?vue&type=script&lang=js&"
export * from "./CreatePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports